import React, { useState, useEffect } from 'react';
import { ModalActionsComponent, SelectIdentitiesComponent } from '@app/components';
import { useTypedTranslation } from '@app/hooks';
import { IActiveFilter, Order, OrderType, ITenants } from '@app/models';
import { dialogComponentsListData, onPressEnterModal, infiniteScrollItemsFetchLimit, genericErrorToast, homeRealm } from '@app/helpers';
import { tenantsService } from '@app/services';

interface IProps {
    sendBackResultsFunction: Function;
    closeDialogFunction: Function;
}

interface ITenantsTableData {
    checked: boolean;
    name: string;
    id: string;
}

export const AddTenantsDialog = (props: IProps) => {
    const { translation } = useTypedTranslation();

    const { sendBackResultsFunction, closeDialogFunction } = props;

    const [rows, setRows] = useState<ITenantsTableData[]>([]);
    const [tenantCount, setTenantCount] = useState<number>();
    const [isChecked, setIsChecked] = useState<boolean>(true);
    const [hasMoreItems, setHasMoreItems] = useState<boolean>();
    const [loadMore, setLoadMore] = useState<number>(dialogComponentsListData);
    const [dataLoading, isDataLoading] = useState<boolean>(false);
    const [selectAllLocal, setSelectAllLocal] = useState<boolean>(false);

    const [order, setOrder] = useState<OrderType>(Order.asc);
    const [orderBy, setOrderBy] = useState(homeRealm);

    useEffect(() => {
        isDataLoading(true);
    }, []);

    const getTenantData = (skipCount: number, isReset: boolean, activeFilters?: IActiveFilter[]) => {
        tenantsService.getTenants(
            orderBy,
            order,
            infiniteScrollItemsFetchLimit,
            skipCount,
            isReset,
            handleSuccess,
            genericErrorToast,
            activeFilters
        );
    }

    const handleSuccess = (response: any) => {
        const count = response.data['@odata.count'];

        if (count !== undefined) {
            setTenantCount(count);
        }

        const results: ITenants[] = response.data.value;

        if (results) {
            let newRows = results.map((tenant: ITenants) => {
                const data: ITenantsTableData = {
                    checked: false,
                    id: tenant.Id,
                    name: tenant.HomeRealm,
                };
                return data;
            });

            if (results.length === 0) {
                setRows([]);
            }
            else if (count !== undefined) {
                setRows(newRows);
            }
            else {
                setRows(rows.concat(newRows));
            }
        }

        isDataLoading(false);
    };

    const handleSetHasMore = (value: any) => {
        setHasMoreItems(value);
    };

    const handleSetValueFilter = (value: any) => {
        const filters: IActiveFilter[] = [
            {
                name: 'contains',
                value: value,
                label: homeRealm,
                filterBy: homeRealm
            }
        ];

        getTenantData(0, true, filters);
    };

    const handleSetFiltered = (value: any) => {
        if (value !== undefined) {
            setRows(value);
        }
    };

    const handleCheck = (value: boolean) => {
        setIsChecked(value);
    };

    const handleAddTenants = () => {
        const checboxSelected = rows.filter((el: ITenantsTableData) => {
            return el.checked === true;
        });

        sendBackResultsFunction(checboxSelected);
    };

    const handleFetchMore = () => {
        if (hasMoreItems) {
            getTenantData(loadMore, true);
            setLoadMore(loadMore + dialogComponentsListData);
        }
    };

    const handleCancel = () => {
        closeDialogFunction();
    };

    return (
        <div tabIndex={0} onKeyPress={onPressEnterModal(handleAddTenants, isChecked)} className='modal__body'>
            <SelectIdentitiesComponent
                filteredItems={rows}
                nonMemberedItems={rows}
                selectAll={selectAllLocal}
                setFilteredItems={handleSetFiltered}
                setHandleCheck={handleCheck}
                fetchMore={handleFetchMore}
                totalCount={tenantCount}
                setHasMoreItems={handleSetHasMore}
                hasMoreItems={hasMoreItems}
                setValueFilter={handleSetValueFilter}
                dataLoading={dataLoading}
            />
            <ModalActionsComponent
                primaryBtn={translation('ADD_TENANTS')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={handleAddTenants}
                onClickSecondary={handleCancel}
                disabled={isChecked}
                id='addTenants'
                withBorder={true}
            />
        </div>
    );
};
